import React from "react";
import { Button, Form, Input, Select, Typography, message } from "antd";
import { Content } from "antd/es/layout/layout";
import {
  CustomerServiceOutlined,
  MessageOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { getTableID } from "../Services/authServices";
import "./style.css";

const { TextArea } = Input;
const { Option } = Select;

const supportHighlights = [
  {
    icon: <CustomerServiceOutlined />,
    title: "Fast review",
    text: "Our team reviews support requests and routes them to the right queue quickly.",
  },
  {
    icon: <WalletOutlined />,
    title: "Wallet and transfer help",
    text: "Use this page for questions about wallet funding, remittance, or transaction issues.",
  },
  {
    icon: <MessageOutlined />,
    title: "Clear updates",
    text: "Provide the key details once and we will follow up with the next steps.",
  },
];

const SupportTicket = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const tableID = await getTableID();
      const input = {
        ticketType: values.category,
        message: values.message,
        userId: tableID,
      };

      const apiUrl =
        "https://lqixii27zj.execute-api.us-east-2.amazonaws.com/default/createSupportTicket-staging";
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(input),
      });

      if (response.ok) {
        message.success("Your support request has been submitted.");
        form.resetFields();
      } else {
        message.error("Failed to submit your support request. Please try again.");
      }
    } catch (err) {
      console.error("Error creating support ticket:", err);
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Content className="appPageContent">
      <div className="appPageShell supportPageShell">
        <div className="appSectionHeader supportPageHeader">
          <div>
            <h1 className="appSectionTitle">Support</h1>
          </div>
        </div>

        <div className="supportPageGrid">
          <div className="appTableCard supportInfoCard">
            <Typography.Title level={4} className="supportCardTitle">
              Before you submit
            </Typography.Title>
            <div className="supportHighlightList">
              {supportHighlights.map((item) => (
                <div key={item.title} className="supportHighlightItem">
                  <span className="supportHighlightIcon">{item.icon}</span>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="appTableCard supportFormCard">
            <Typography.Title level={4} className="supportCardTitle">
              Submit a support request
            </Typography.Title>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              requiredMark={false}
              className="supportForm"
            >
              <Form.Item
                label="Category"
                name="category"
                rules={[
                  { required: true, message: "Please select a category." },
                ]}
              >
                <Select placeholder="Select a category">
                  <Option value="GENERAL">General</Option>
                  <Option value="WITHDRAW">Withdraw</Option>
                  <Option value="TRANSACTION">Transaction</Option>
                  <Option value="WALLET">Wallet</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Message"
                name="message"
                rules={[
                  { required: true, message: "Please enter your message." },
                  { min: 10, message: "Message must be at least 10 characters." },
                ]}
              >
                <TextArea
                  rows={6}
                  placeholder="Example: I want to request a withdrawal of 615 CAD."
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={loading}
                  className="signupbtn supportSubmitBtn"
                >
                  {loading ? "Submitting..." : "Submit Request"}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default SupportTicket;
